import React from "react";
import Container from "../Layout/Container";
import { connect } from "react-redux";
import {
  getAllSuppliers,
  postSupplier,
  deleteSupplier,
  updateSupplier,
  clearErrors,
} from "../../redux/Actions/supplierAction";
import SuppliersEditModal from "./Items/SupplierEditModal";
import ContentBlock from "../Layout/ContentBlock";
import Pagination from "../Dashboard/items/Pagination";
import TableColumnSuppliers from "./Items/TableColumnSupplier";
import FilterMenu from "../Layout/FilterMenu";
import TableFilterBox from "../common/TableFilterBox";
import ContentValidation from "../common/ContentValidation";
import { getPickupAddressesOption } from "../../redux/Actions/pickupAddressAction";
import { TextInput } from "../globals";
import { getCountriesAllOptions } from "../../redux/Actions/countryAction";
import { getDeliveryTimes } from "../../redux/Actions/deliveryTimeAction";

class Suppliers extends React.Component {
  constructor() {
    super();
    this.state = {
      nameValue: "",
      is_codeValue: false,
      is_activeValue: false,
      page: 1,
      pageCount: 100,
      commentValue: "",
      requiredId: 0,
      action: "new",
      pickup_addresses: [],
      titleFilter: "",
      codeFilter: "",
      departmentCodeFilter: "",
      rivileSupplierCodeFilter: "",
      filterString: "",
      countries: [],
      delivery_times: [],
    };
  }
  componentDidMount() {
    this.props.getAllSuppliers(
      this.state.page,
      this.state.pageCount,
      this.state.filterString
    );
    getPickupAddressesOption().then((res) => {
      if (res.data && res.data.data) {
        this.setState({
          pickup_addresses: res.data.data.map((e) => ({
            value: e.id,
            label: `${e.code || ""} - ${e.address || ""}, ${e.city || ""}`,
          })),
        });
      }
    });
    getCountriesAllOptions().then((res) => {
      if (res.data) {
        this.setState({
          countries: res.data.map((e) => ({
            value: e.id,
            label: e.name,
          })),
        });
      }
    });
    getDeliveryTimes().then((res) => {
      if (res.data) {
        this.setState({
          delivery_times: res.data.map((e) => ({
            value: e.code,
            label: e.title,
          })),
        });
      }
    });
  }

  componentDidUpdate(_, prevState) {
    if (
      prevState.page !== this.state.page ||
      prevState.pageCount !== this.state.pageCount
    ) {
      this.props.getAllSuppliers(
        this.state.page,
        this.state.pageCount,
        this.state.filterString
      );
    }
  }

  onAction = (action, index) => {
    this.setState({
      requiredId: index,
      action: action,
    });
  };

  setPagination = (page) => {
    this.setState({
      page,
    });
  };
  setPageCount = (pageCount) => {
    this.setState({
      pageCount,
      page: 1,
    });
  };

  onFilter = async () => {
    let filterString = "";

    if (this.state.titleFilter) {
      filterString += `&q[title_cont_any]=${this.state.titleFilter}`;
    }
    if (this.state.codeFilter) {
      filterString += `&q[name_cont_any]=${this.state.codeFilter}`;
    }
    if (this.state.departmentCodeFilter) {
      filterString += `&q[code_cont_any]=${this.state.departmentCodeFilter}`;
    }
    if (this.state.rivileSupplierCodeFilter) {
      filterString += `&q[rivile_supplier_code_cont_any]=${this.state.rivileSupplierCodeFilter}`;
    }

    await this.setState({ filterString });

    await this.props.getAllSuppliers(
      this.state.page,
      this.state.pageCount,
      this.state.filterString
    );
  };

  onClearFilter = async () => {
    await this.setState({
      titleFilter: "",
      codeFilter: "",
      departmentCodeFilter: "",
      rivileSupplierCodeFilter: "",
      filterString: "",
    });
    await this.props.getAllSuppliers(
      this.state.page,
      this.state.pageCount,
      this.state.filterString
    );
  };

  render() {
    const requiredItem = this.state.requiredId;
    let modalData = this.props.suppliersItems[requiredItem]
      ? this.props.suppliersItems[requiredItem]
      : [];
    return (
      <Container
        location={{
          locationName: "Suppliers",
          locationUrl: this.props.match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            totals={this.props.totals}
            length={this.props.suppliersItems.length}
            onChangeCountPage={this.setPageCount}
            countPage={this.state.pageCount}
            text2="Suppliers"
          />
        </ContentBlock>
        <ContentBlock>
          <TableFilterBox
            filter={true}
            add={this.onAction}
            onFilter={() => this.onFilter()}
            clearFilter={() => this.onClearFilter()}
          >
            <div className="col-12 row">
              <div className="col-2-5 px-2">
                <TextInput
                  text="Title"
                  name="title"
                  value={this.state.titleFilter}
                  onChange={(e) =>
                    this.setState({ titleFilter: e.target.value })
                  }
                />
              </div>
              <div className="col-2-5 px-2">
                <TextInput
                  text="Code"
                  name="code"
                  value={this.state.codeFilter}
                  onChange={(e) =>
                    this.setState({ codeFilter: e.target.value })
                  }
                />
              </div>
              <div className="col-2-5 px-2">
                <TextInput
                  text="Department code"
                  name="department_code"
                  value={this.state.departmentCodeFilter}
                  onChange={(e) =>
                    this.setState({
                      departmentCodeFilter: e.target.value,
                    })
                  }
                />
              </div>
              <div className="col-2-5 px-2">
                <TextInput
                  text="Rivile supplier code"
                  name="rivile_supplier_code"
                  value={this.state.rivileSupplierCodeFilter}
                  onChange={(e) =>
                    this.setState({
                      rivileSupplierCodeFilter: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation
              loader={this.props.loading_suppliers}
              array={this.props.suppliersItems}
              alertId_s="supAlert-s"
              alertId_e="supAlert-e"
            >
              <div className="table-responsive">
                <table className="table table-sm table-hover mt-3">
                  <thead>
                    <tr className="text-muted">
                      <th className="text-black">#</th>
                      <th className="text-black">Title</th>
                      <th className="text-black">Code</th>
                      <th className="text-black">In PIM?</th>
                      <th className="text-black">Department code</th>
                      <th className="text-black">BB Rivile supplier code</th>
                      <th className="text-black">VV Rivile supplier code</th>
                      <th className="text-black">Pickup address</th>
                      <th className="text-black">Country</th>
                      <th className="text-black">Is code?</th>
                      <th className="text-black">Is active?</th>
                      <th className="text-black">Comments</th>
                      <th className="text-black">Auto invoice</th>
                      <th className="text-black">Parent supplier</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.suppliersItems.map((item, index) => {
                      return (
                        <TableColumnSuppliers
                          key={index}
                          index={index}
                          item={item}
                          onEdit={this.onAction}
                          onDelete={this.props.deleteSupplier}
                        />
                      );
                    })}
                  </tbody>
                </table>
                <Pagination
                  setPagination={this.setPagination}
                  page={this.state.page}
                  totals={this.props.totals}
                  pageCount={this.state.pageCount}
                />
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>

        <SuppliersEditModal
          action={this.state.action}
          postSupplier={this.props.postSupplier}
          updateSupplier={this.props.updateSupplier}
          objectData={modalData}
          clearErrors={this.props.clearErrors}
          errors={this.props.errors}
          pickup_addresses={this.state.pickup_addresses}
          countries={this.state.countries}
          delivery_times={this.state.delivery_times}
        />
      </Container>
    );
  }
}
const mapStateToProps = (state) => ({
  suppliersItems: state.supplier.suppliers,
  totals: state.supplier.totals,
  loading_suppliers: state.supplier.loading_supplier,
  errors: state.errors,
});

export default connect(mapStateToProps, {
  getAllSuppliers,
  postSupplier,
  deleteSupplier,
  updateSupplier,
  clearErrors,
})(Suppliers);
